import { useQuery } from '@tanstack/react-query';

import ReconciliationsApiHandler from 'app/services/reconciliationsApiHandler';

import {
  ListPage,
  ReconciliationCompaniesRequest,
  ReconciliationCompany,
} from 'app/types/reconciliations';

export const RECONCILIATION_COMPANIES_QUERY_KEY = 'fetchReconciliationCompanies';

/** Lists the companies a reconciliation run checked or failed to check, failed first. */
const useFetchReconciliationCompanies = (
  { id, companyId, status, page, size }: ReconciliationCompaniesRequest,
  enabled = true
) =>
  useQuery<ListPage<ReconciliationCompany>, Error>(
    [RECONCILIATION_COMPANIES_QUERY_KEY, id, companyId, status, page, size],
    () =>
      ReconciliationsApiHandler.listReconciliationCompanies({ id, companyId, status, page, size }),
    { enabled: enabled && !!id, keepPreviousData: true }
  );

export default useFetchReconciliationCompanies;
